import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";
import { EventHostComplete } from "../../../models/event-hosts/event-host-complete.model";

export const adminHostAdapter: EntityAdapter<EventHostComplete> = createEntityAdapter<EventHostComplete>({ 
    selectId: (host) => host.hostID,
    sortComparer: (a,b) => a.name.localeCompare(b.name)
});